import React, { useState } from "react";
import ChoosePlan from "./ChoosePlan";
import CheckoutDetails from "./CheckoutDetails";
import ChoosePlanPricing from "./ChoosePlanPricing";
import { Button } from "appStyles";
import { tiers } from "constants";
import { css } from "react-emotion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const storeContainer = css`
  margin: 0px 20px;
  @media only screen and (min-width: 768px) {
    margin: 0px 40px;
  }
`;
const mdcButton = css`
  background-color: rgb(235, 255, 255);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;

const arrowStyle = css`
  font-size: 1.3em;
  display: flex;
  align-self: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    font-size: 2em;
    cursor: pointer;
    display: flex;
    align-self: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;
function Checkout({ ...props }) {
  const appId = new URLSearchParams(window.location.search).get("appId");
  if (!appId) props.history.push("/lobby");

  const [checkOutStep, setCheckOutStep] = useState(0);
  const [plan, setPlan] = useState(tiers[2]);
  // console.log("checkout got updated plan...");
  // console.dir(plan);
  const steps = [
    <ChoosePlanPricing plan={plan} setPlan={setPlan} />,
    <CheckoutDetails
      {...props}
      plan={plan}
      // setPlan={setPlan}
    />,
    // <ChoosePlan
    //   plan={plan}
    //   setPlan={setPlan}
    // />
  ];

  const Steps = () => {
    return steps[Math.min(checkOutStep, steps.length - 1)];
  };
  const NextButton = () => {
    if (steps.length - 1 === checkOutStep) return null;

    return (
      <Button
        cursor="pointer"
        style={{
          display: "inline-flex",
          alignItems: "center",
          margin: "0px",
          textAlign: "center",
          backgroundColor: "#89d2d3",
          boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
          position: "absolute",
          right: "50px",
          bottom: "25px",
          width: "450px",
          fontWeight: "bold",
          fontSize: "20px",
        }}
        className={mdcButton}
        onClick={() => setCheckOutStep(checkOutStep + 1)}
      >
        Next
      </Button>
    );
  };
  const BackButton = () => {
    if (steps.length - 1 != checkOutStep) return null;
    return (
      <div className={storeContainer}>
        <FontAwesomeIcon
          className={arrowStyle}
          icon="arrow-left"
          onClick={() => setCheckOutStep(checkOutStep - 1)}
        />
      </div>
    );
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        background: "white",
        position: "relative",
      }}
    >
      <BackButton />
      <Steps />
      <NextButton />
    </div>
  );
}

export default Checkout;
